var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "product__basket-mobile position-fixed w-100 b-0 l-0 px-prj2 pt-prj2 pb-4 bg-shade-light hide-for-large hide-for-print",
        class: { "bg-error": !_vm.configurationComplete },
      },
      [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "small-12 columns product__basket-mobile-split" },
            [
              _c(
                "div",
                { staticClass: "product__basket-mobile-split-info" },
                [
                  _vm.configurationComplete
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-between mb-1 mb-3@large",
                        },
                        [
                          _c("div", { staticClass: "text-xsmall" }, [
                            _vm._v(_vm._s(_vm._f("translate")("txtExclVAT"))),
                          ]),
                          _vm._v(" "),
                          _vm.priceExclVat
                            ? _c(
                                "div",
                                { staticClass: "text-small text-align-right" },
                                [_vm._v(_vm._s(_vm.priceExclVat))]
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.configurationComplete && _vm.normalPrice && _vm.savings
                    ? [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-between mb-1 mb-3@large",
                          },
                          [
                            _c("div", { staticClass: "text-xsmall" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("translate")("txtBasketPriceRegulaer")
                                ) + " "
                              ),
                              _c("span", { staticClass: "text-xxsmall" }, [
                                _vm._v(
                                  _vm._s(_vm._f("translate")("txtExclVAT"))
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "text-small text-align-right" },
                              [_vm._v(_vm._s(_vm.normalPrice))]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-between mb-1 mb-3@large",
                          },
                          [
                            _c("div", { staticClass: "text-xsmall" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("translate")("txtBasketPriceSaved")
                                ) + " "
                              ),
                              _c("span", { staticClass: "text-xxsmall" }, [
                                _vm._v(
                                  _vm._s(_vm._f("translate")("txtExclVAT"))
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "text-small text-align-right" },
                              [_vm._v(_vm._s(_vm.savings))]
                            ),
                          ]
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.configurationComplete
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-end",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "font-weight-bold text-xsmall" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("translate")(
                                    "txtInclVAT",
                                    _vm.globalConfig.vat
                                  )
                                )
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.priceInclVat
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "font-weight-bold text-align-right",
                                },
                                [_vm._v(_vm._s(_vm.priceInclVat))]
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.configurationComplete && _vm.liefertermin
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-end mt-1",
                        },
                        [
                          _c("div", { staticClass: "text-xsmall" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("translate")("txtVersandterminShort")
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "text-small text-align-right" },
                            [_vm._v(_vm._s(_vm.liefertermin))]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.configurationComplete
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "d-flex py-2 text-white text-small line-height-12",
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass:
                                "mr-2 svg-icon flex-child-fix position-relative t-1px",
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 36 36",
                              },
                            },
                            [
                              _c("circle", {
                                attrs: {
                                  cx: "18",
                                  cy: "18",
                                  r: "18",
                                  fill: "#fff",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z",
                                  fill: "#e94d47",
                                },
                              }),
                            ]
                          ),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.statusMsg) +
                              "\n          "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "mt-2" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn w-100 btn-basket",
                    attrs: { disabled: !_vm.configurationComplete },
                    on: { click: _vm.toBasket },
                  },
                  [_vm._v(_vm._s(_vm._f("translate")("btnAddToBasket")))]
                ),
              ]),
            ]
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "product__basket-desktop mb-3" }, [
      _c(
        "div",
        {
          staticClass:
            "product__basket-title p-4 bg-secondary text-white font-weight-bold text-center show-for-large",
        },
        [
          _vm._v(
            "\n            " +
              _vm._s(_vm._f("translate")("txtMyOffer")) +
              "\n        "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "p-prj2 pt-4 bg-shade-light show-for-large" },
        [
          this.configuratorService.isConfigTypePresent(_vm.printqService.TYPE)
            ? _c("PrintQ3DOverlay")
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex justify-content-between",
              class: { "mb-2": _vm.savings, "mb-3": !_vm.savings },
            },
            [
              _c("div", { staticClass: "text-xsmall" }, [
                _vm._v(_vm._s(_vm._f("translate")("txtExclVAT"))),
              ]),
              _vm._v(" "),
              _vm.priceExclVat
                ? _c("div", { staticClass: "text-small text-align-right" }, [
                    _vm._v(_vm._s(_vm.priceExclVat)),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _vm.normalPrice && _vm.savings
            ? [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-end mb-2",
                  },
                  [
                    _c("div", { staticClass: "text-xsmall" }, [
                      _vm._v(
                        _vm._s(_vm._f("translate")("txtBasketPriceRegulaer")) +
                          " "
                      ),
                      _c("span", { staticClass: "text-xxsmall" }, [
                        _vm._v(_vm._s(_vm._f("translate")("txtExclVAT"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-small text-align-right" }, [
                      _vm._v(_vm._s(_vm.normalPrice)),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-end mb-2",
                  },
                  [
                    _c("div", { staticClass: "text-xsmall" }, [
                      _vm._v(
                        _vm._s(_vm._f("translate")("txtBasketPriceSaved")) + " "
                      ),
                      _c("span", { staticClass: "text-xxsmall" }, [
                        _vm._v(_vm._s(_vm._f("translate")("txtExclVAT"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-small text-align-right" }, [
                      _vm._v(_vm._s(_vm.savings)),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("hr", { staticClass: "mb-2 mt-2 bg-white" }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex justify-content-between align-items-end" },
            [
              _c("div", { staticClass: "font-weight-bold text-xsmall" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("translate")("txtInclVAT", _vm.globalConfig.vat)
                  )
                ),
              ]),
              _vm._v(" "),
              _vm.priceInclVat
                ? _c(
                    "div",
                    { staticClass: "font-weight-bold text-align-right" },
                    [_vm._v(_vm._s(_vm.priceInclVat))]
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          this.configuratorService.observableData.herstellkosten
            ? _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-end mt-3",
                },
                [
                  _c("div", { staticClass: "text-xsmall" }, [
                    _vm._v("Herstellkosten (exkl. MwSt)"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-small text-align-right" }, [
                    _vm._v(
                      _vm._s(
                        this.configuratorService.observableData.herstellkosten
                          .currency
                      ) +
                        " " +
                        _vm._s(
                          this.configuratorService.observableData.herstellkosten
                            .exclVat
                        )
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.configurationComplete
            ? _c(
                "div",
                {
                  staticClass:
                    "d-flex mt-2 p-2 bg-error text-white text-small line-height-12",
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass:
                        "mr-2 svg-icon flex-child-fix position-relative t-1px",
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 36 36",
                      },
                    },
                    [
                      _c("circle", {
                        attrs: { cx: "18", cy: "18", r: "18", fill: "#fff" },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z",
                          fill: "#e94d47",
                        },
                      }),
                    ]
                  ),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.statusMsg) +
                      "\n            "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("hr", { staticClass: "mb-2 mt-2 bg-white" }),
          _vm._v(" "),
          _vm.liefertermin
            ? _c(
                "div",
                {
                  staticClass: "d-flex justify-content-between align-items-end",
                },
                [
                  _c("div", { staticClass: "text-xsmall" }, [
                    _vm._v(
                      _vm._s(_vm._f("translate")("txtVersandterminShort"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-small text-align-right" }, [
                    _vm._v(_vm._s(_vm.liefertermin)),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "mt-4" }, [
            _c(
              "a",
              {
                staticClass: "btn w-100 btn-basket",
                attrs: { disabled: !_vm.configurationComplete },
                on: { click: _vm.toBasket },
              },
              [
                _vm._v(
                  _vm._s(
                    _vm._f("translate")(
                      _vm.shopItemId ? "btnUpdateBasket" : "btnAddToBasket"
                    )
                  )
                ),
              ]
            ),
          ]),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }